<template>
  <div class="mb-8 main-feature-wrap">
    <div class="section-kicker-bar text-center mb-2">
      <v-chip small color="primary" class="kicker-chip" outlined>
        <v-icon small left>mdi-star-four-points-outline</v-icon>
        {{ $t('header.feature') }}
      </v-chip>
    </div>
    <h1 class="my-4 text-center title-style">{{ title }}</h1>
    <p class="text-center feature-subtitle mb-8">{{ $t('brand.desc') }}</p>
    <v-row class="ma-0">
      <v-col class="px-2 pb-6" md="6" cols="12" v-for="(item, index) in features" :key="index">
        <div class="services-card">
          <div class="services-card-accent"></div>
          <div class="left">
            <div class="icon-wrap">
              <v-icon color="primary" class="icon">{{ item.icon }}</v-icon>
            </div>
          </div>
          <div class="right">
            <h2 class="service-title">{{ item.title }}</h2>
            <p class="service-body ma-0">{{ item.body }}</p>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<style scoped lang="scss">
@import "./feature-styles";
</style>

<script>
export default {
  props: {
    features: {
      default: [],
      type: Array
    },
    title: {
      default: "",
      type: String
    }
  }
};
</script>